// Production logging utility - Aggressively disable console logging
// Only shows errors in production, all other logs are disabled

// Force disable all console logging except errors
const disableConsoleLogging = () => {
  const noop = () => {};
  
  // Override all console methods except error
  if (typeof console !== 'undefined') {
    console.log = noop;
    console.info = noop;
    console.warn = noop;
    console.debug = noop;
    // Keep console.error for actual errors
  }
};

// Apply immediately
disableConsoleLogging();

// Also apply on window load to ensure it's applied
if (typeof window !== 'undefined') {
  window.addEventListener('load', disableConsoleLogging);
  // Also apply on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', disableConsoleLogging);
}

export const logger = {
  log: (...args: any[]) => {
    // Disabled in production
  },
  
  info: (...args: any[]) => {
    // Disabled in production
  },
  
  warn: (...args: any[]) => {
    // Disabled in production
  },
  
  error: (...args: any[]) => {
    // Always show errors
    console.error(...args);
  },
  
  debug: (...args: any[]) => {
    // Disabled in production
  },
  
  // Special method for critical system messages that should always show
  critical: (...args: any[]) => {
    console.error('[CRITICAL]', ...args);
  }
}; 